import { useSelector } from "react-redux";
import { useKeyDown } from "@netapp/bxp-design-system-react";
import SearchResults from "./SearchResults";
import RecentResults from "./RecentResults";
import { useTranslation } from 'react-i18next';
import { globalSearch as i18nNamespace} from "../../../i18n/namespace";
import { SEARCH_MIN_LENGTH } from "../consoleObjects";
import styles from "../GlobalSearch.module.scss";

const Results = ({focusGlobalSearch}) => {
    const { t } = useTranslation(i18nNamespace);
    const recentSearches = useSelector(state => state.globalSearch.recentSearches) || [];
    const isSearchPerformed = useSelector(state => state.globalSearch.isSearchPerformed);
    const searchTerm = useSelector(state => state.globalSearch.searchTerm) || "";
    useKeyDown(() => {
      focusGlobalSearch();
    }, ['Escape'])

    const isQueryTooShort = !isSearchPerformed && searchTerm.trim().length > 0 && searchTerm.trim().length < SEARCH_MIN_LENGTH;
    const showRecentSearches = !isSearchPerformed && !isQueryTooShort && recentSearches.length > 0;
    const showGuidance = !showRecentSearches && !isSearchPerformed && !isQueryTooShort;

    return <div className={styles['results-container']}>
        <div
            className={styles.results}
            onMouseDown={event => event.preventDefault()}
            onClick={event => event.stopPropagation()}
        >
            {(isQueryTooShort || showGuidance) && <div className={`${styles.message} ${styles.centered}`}>{t('min_characters_message')}</div>}
            {showRecentSearches && <RecentResults recentSearches={recentSearches} focusGlobalSearch={focusGlobalSearch} />}
            {isSearchPerformed && <SearchResults />}
        </div>
    </div>
};

export default Results;